var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortlistIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5049 14.295L12.2549 11.295C11.9849 11.1975 11.6774 11.265 11.4674 11.4675C11.2574 11.67 11.1899 11.9775 11.2949 12.255L14.2949 20.505C14.3999 20.7975 14.6774 20.9925 14.9849 21H14.9999C15.3074 21 15.5849 20.8125 15.6974 20.5275L16.7774 17.835L18.9749 20.0325C19.1249 20.1825 19.3124 20.25 19.5074 20.25C19.7024 20.25 19.8899 20.175 20.0399 20.0325C20.3324 19.74 20.3324 19.2675 20.0399 18.975L17.8424 16.7775L20.5349 15.6975C20.8199 15.585 21.0074 15.3 21.0074 14.9925C21.0074 14.685 20.8049 14.4075 20.5124 14.3025L20.5049 14.295Z",
    fill: "url(#paint0_linear_3874_900)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.41 10.41C11.025 9.795 11.9475 9.5925 12.765 9.885L15.285 10.8C16.0725 9.4875 16.5 8.115 16.5 6.75C16.5 4.68 14.82 3 12.75 3C11.5275 3 10.4325 3.5925 9.75 4.5C9.0675 3.585 7.9725 3 6.75 3C4.68 3 3 4.68 3 6.75C3 9.975 5.3175 13.215 9.3675 15.645C9.4875 15.72 9.6225 15.75 9.75 15.75C9.8775 15.75 10.02 15.7125 10.1325 15.645C10.3575 15.51 10.5675 15.375 10.7775 15.24L9.8775 12.7725C9.5775 11.955 9.7875 11.025 10.4025 10.41H10.41Z",
    fill: "url(#paint1_linear_3874_900)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3874_900",
    x1: 16.1268,
    y1: 11.251,
    x2: 16.1268,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3874_900",
    x1: 9.75,
    y1: 3,
    x2: 9.75,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortlistIcon);
export default __webpack_public_path__ + "static/media/shortlist-icon.e462c1d973f9cafe695ee7e79368f3cc.svg";
export { ForwardRef as ReactComponent };